import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Button,
  Typography,
  Tag,
  Descriptions,
  Space,
  Divider,
  Modal,
  message,
  Image,
  Select,
  Table,
  Progress,
  Card,
  Radio,
} from 'antd';
import { Column } from '@ant-design/plots';
import ProTable from '@ant-design/pro-table';
import {
  FileSearchOutlined,
  PlayCircleTwoTone,
  UserOutlined,
  MessageOutlined,
  ClockCircleOutlined,
  SmileOutlined,
  PictureOutlined,
  CalendarOutlined,
  RobotOutlined,
  PieChartOutlined,
  LineChartOutlined,
} from '@ant-design/icons';
import { history } from 'umi';
import { guuid } from '@/utils/utils';
import ModalVideo from '@/components/ModalVideoXg';
import MarkdownView from '@/components/MarkdownView';
import CheckInOverview from './CheckInOverview';

import {
  userOverview,
  alreadyAddWxUser,
  alreadyAddServiceGroup,
  alreadyAddDailyGroup,
  location,
  sportAction,
  setServiceGroupExclusive,
  subrecord,
  renewrecord,
  getSpaceInfo,
  queryUserMoment,
  queryUserPool,
  queryUserFollowing,
  queryUserFollowed,
  queryUserSpace,
  userOverviewCoach,
  rewardRecordPage,
  periodAppointLogPage,
  weekPlanRecordPage,
  getChartIdList,
  sendAiAnalyse,
  getAiAnalyseInfo,
  pageList,
  getUserPortrait,
  queryNotifyContentWithInit,
  setNotifyContent,
} from '@/services/userManager';
const { Paragraph } = Typography;

// 基础标签 type → 颜色，未命中的 type 走兜底红色
const BASE_LABEL_COLOR = {
  1: 'skyblue',
  3: '#EEB166', // srgb(238, 177, 102)
};
const BASE_LABEL_COLOR_FALLBACK = 'red';

const OverView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId, step } = props;

  const sourceEnum = {
    0: { text: '系统初始化' },
    1: { text: '小程序' },
    2: { text: '侧边栏' },
    3: { text: '商家APP' },
  };

  const FrequencyDays = [
    'default',
    '每周一',
    '每周二',
    '每周三',
    '每周四',
    '每周五',
    '每周六',
    '每周日',
  ];

  const [overViewData, setOverViewData] = useState();
  const [getSpaceInfoData, setGetSpaceInfoData] = useState();
  // 用户画像数据
  const [userPortraitData, setUserPortraitData] = useState();

  const [playerVisible, setPlayerVisible] = useState(false);
  const [playUrl, setPlayerUrl] = useState('');
  // 关注公众号
  const [subscribeModalVisible, setSubscribeModalVisible] = useState(false);

  const [chatId, setChatId] = useState('');
  const [chartIdList, setChartIdList] = useState([]);
  const [showAiLoading, setShowAiLoading] = useState(true);
  const [aiContent, setAiContent] = useState();
  const [aiCurrentPage, setAiCurrentPage] = useState(1);
  const [aiTotal, setAiTotal] = useState(0);
  const [aiList, setAiList] = useState([]);
  const [aiDetailVisible, setAiDetailVisible] = useState(false);
  const [aiDetailRecord, setAiDetailRecord] = useState();
  const aiColumns = [
    {
      title: '时间',
      dataIndex: 'reportTimeRange',
      key: 'reportTimeRange',
    },
    {
      title: '会员发言条数',
      dataIndex: ['dataOverview', 'keyMetrics', 'memberMessageCount'],
      key: 'memberMessageCount',
    },
    {
      title: '教练发言条数',
      dataIndex: ['dataOverview', 'keyMetrics', 'coachMessageCount'],
      key: 'coachMessageCount',
    },
    {
      title: '平均响应时间',
      render: (_, record) => {
        const avg = record?.dataOverview?.keyMetrics?.averageResponseTime;
        if (!avg) return '-';
        return `${avg.value}${
          avg.unit === 'minutes' ? '分钟' : avg.unit || ''
        }`;
      },
      key: 'averageResponseTime',
    },
    {
      title: '积极情绪占比',
      dataIndex: ['dataOverview', 'keyMetrics', 'positiveSentimentRatio'],
      key: 'positiveSentimentRatio',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Button
          type="link"
          size="small"
          style={{ padding: 0 }}
          onClick={() => openAiDetail(record)}
        >
          详情
        </Button>
      ),
    },
  ];
  const insightColumns = [
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      render: (text) => (
        <Tag
          color={
            text?.includes('POTENTIAL_NEED')
              ? 'green'
              : text?.includes('RISK_ALERT')
              ? 'red'
              : 'blue'
          }
        >
          {text === 'RISK_ALERT'
            ? '风险预警'
            : text === 'POTENTIAL_NEED'
            ? '潜在需求'
            : text === 'POSITIVE_FEEDBACK'
            ? '积极反馈'
            : text || ''}
        </Tag>
      ),
    },
    {
      title: '洞察内容',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '相关对话摘录',
      dataIndex: 'dialogueSummary',
      key: 'dialogueSummary',
    },
  ];
  function openAiDetail(record) {
    setAiDetailRecord(record);
    setAiDetailVisible(true);
  }
  function closeAiDetail() {
    setAiDetailVisible(false);
    setAiDetailRecord(undefined);
  }
  function toPercentNumber(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    const s = String(v).trim();
    if (s.endsWith('%')) return parseFloat(s.replace('%', ''));
    const n = parseFloat(s);
    return Number.isNaN(n) ? 0 : n;
  }

  const subscribeColumns = [
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  // 周训练安排
  const [arrangeModalVisible, setArrangeModalVisible] = useState(false);
  const arrangeColumns = [
    {
      title: '操作时间',
      dataIndex: 'operationTime',
      key: 'operationTime',
    },
    {
      title: '操作方式',
      dataIndex: 'source',
      key: 'source',
      valueType: 'select',
      valueEnum: sourceEnum,
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      key: 'operator',
    },
  ];

  // 周训练安排
  const [periodModalVisible, setPeriodModalVisible] = useState(false);
  const periodColumns = [
    {
      title: '操作时间',
      dataIndex: 'operationTime',
      key: 'operationTime',
    },
    {
      title: '操作方式',
      dataIndex: 'source',
      key: 'source',
      valueType: 'select',
      valueEnum: sourceEnum,
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      key: 'operator',
    },
  ];

  // 健康金
  const [coinModalVisible, setCoinModalVisible] = useState(false);
  const coinColumns = [
    {
      title: '发生时间',
      dataIndex: 'recordTime',
      key: 'recordTime',
    },
    {
      title: '类型',
      dataIndex: 'recordDesc',
      key: 'recordDesc',
    },
    {
      title: '健康金数量',
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record, index, action) => {
        const cl = record.type === 1 ? 'green' : 'red';
        return (
          <div style={{ color: cl }}>{`${record.type === 1 ? '+' : '-'} ${
            record.amount
          }`}</div>
        );
      },
    },
  ];

  // 自动续费记录
  const [autoRenewModalVisible, setAutoRenewModalVisible] = useState(false);
  const autoRenewColumns = [
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '签约商品模板',
      dataIndex: 'template',
      key: 'template',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  // 已加企微
  const [qwModalVisible, setQwModalVisible] = useState(false);
  const qwColumns = [
    {
      title: '已加企微',
      dataIndex: 'wxUserName',
      key: 'wxUserName',
    },
    {
      title: '添加时间',
      dataIndex: 'addTime',
      key: 'addTime',
    },
  ];

  // 已加服务群
  const alreadyAddWxUserRef = useRef();
  const [alreadyAddWxUserVisible, setAlreadyAddWxUserVisible] = useState(false);
  const alreadyAddWxUserColumns = [
    {
      title: '已加服务群',
      dataIndex: 'name',
      key: 'name',
      render: (_, record, index, action) => {
        return (
          <span>
            <Tag hidden={!record.isExclusiveServiceGroup} color="green">
              专属服务群
            </Tag>
            <span>{record.name}</span>
          </span>
        );
      },
    },
    {
      title: '入群时间',
      dataIndex: 'addTime',
      key: 'addTime',
    },
    {
      title: '操作',
      // dataIndex: '',
      valueType: 'option',
      align: 'center',
      render: (_, record, index, action) => {
        return record.isExclusiveServiceGroup ? (
          ''
        ) : (
          <Button
            type={'link'}
            onClick={() => setExclusiveServiceGroup(record)}
          >
            设为专属群
          </Button>
        );
      },
    },
  ];

  // 已加打卡群
  const [
    alreadyAddDailyGroupModalVisible,
    setAlreadyAddDailyGroupQwModalVisible,
  ] = useState(false);
  const alreadyAddDailyGroupColumns = [
    {
      title: '已加打卡群',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '入群时间',
      dataIndex: 'addTime',
      key: 'addTime',
    },
  ];

  // 地理位置
  const [locationModalVisible, setLocationModalVisible] = useState(false);
  const locationColumns = [
    {
      title: '地理位置',
      dataIndex: 'location',
      key: 'location',
    },
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
  ];

  // 动作详情
  const actionRef = useRef();
  const [currentActionId, setCurrentActionId] = useState();
  const [currentMarkType, setCurrentMarkType] = useState();
  const [currentActionName, setCurrentActionName] = useState();
  const [actionModalVisible, setActionModalVisible] = useState(false);

  // 运动提醒设置
  const [notifyModalVisible, setNotifyModalVisible] = useState(false);
  const [notifyConfigList, setNotifyConfigList] = useState([]);
  const [notifySaving, setNotifySaving] = useState(false);

  const openNotifyModal = async () => {
    try {
      const res = await queryNotifyContentWithInit({
        requestData: { userId: userId },
      });
      if (res?.code === '00000') {
        setNotifyConfigList(res?.data?.notifyConfigList || []);
        setNotifyModalVisible(true);
      } else {
        message.error(res?.msg || '获取提醒设置失败');
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleNotifyStatusChange = (index, value) => {
    const newList = [...notifyConfigList];
    newList[index].status = value;
    setNotifyConfigList(newList);
  };

  const saveNotifyContent = async () => {
    try {
      setNotifySaving(true);
      const res = await setNotifyContent({
        requestData: {
          userId: userId,
          notifyConfigList: notifyConfigList,
        },
      });
      if (res?.code === '00000' && res?.data?.result) {
        message.success('保存成功');
        setNotifyModalVisible(false);
      } else {
        message.error(res?.msg || res?.data?.desc || '保存失败');
      }
    } catch (e) {
      console.error(e);
      message.error('保存异常');
    } finally {
      setNotifySaving(false);
    }
  };

  const notifyModalView = () => {
    return (
      <Modal
        title="运动提醒设置"
        visible={notifyModalVisible}
        open={notifyModalVisible}
        onCancel={() => setNotifyModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setNotifyModalVisible(false)}>
            取消
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={notifySaving}
            onClick={saveNotifyContent}
          >
            保存
          </Button>,
        ]}
        width={600}
      >
        {notifyConfigList.map((item, index) => (
          <div
            key={index}
            style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}
          >
            <span style={{ width: 200 }}>{item.name}</span>
            <Radio.Group
              value={item.status}
              onChange={(e) => handleNotifyStatusChange(index, e.target.value)}
            >
              <Radio value={1}>开启</Radio>
              <Radio value={0}>关闭</Radio>
            </Radio.Group>
          </div>
        ))}
      </Modal>
    );
  };

  const actionColumns = [
    {
      title: '运动时间',
      dataIndex: 'actionTime',
      key: 'actionTime',
    },
    {
      title: '查看视频',
      // dataIndex: '',
      valueType: 'option',
      align: 'center',
      render: (_, record, index, action) => {
        return record.actionUrl ? (
          <PlayCircleTwoTone onClick={() => playActionUrl(record.actionUrl)} />
        ) : (
          ''
        );
      },
    },
  ];

  const [userPoolVisible, setUserPoolVisible] = useState(false); // 家庭账户
  const userPoolColumns = [
    {
      title: '关联人',
      dataIndex: 'phone',
      key: 'phone',
      render: (_, record, index, action) => {
        return (
          <div>
            <div>
              {record.nickName}{' '}
              <Tag color={record.userRole == 1 ? '#d96f79' : '#6767f6'}>
                {record.userRole == 1 ? '主卡' : '副卡'}
              </Tag>
            </div>
            <div
              style={{
                fontSize: 12,
                color: 'gray',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => {
                const { origin } = window.location;
                const pathname = `/litta-palmer/user/record?id=${record.userId}&phone=${record.phone}`;
                window.open(origin + pathname);
              }}
            >
              {record.phone}
            </div>
          </div>
        );
      },
    },
    {
      title: '关联时间',
      dataIndex: 'bindTime',
      key: 'bindTime',
    },
    {
      title: '关联方式',
      dataIndex: 'bindTypeName',
      key: 'bindTypeName',
    },
    {
      title: ' 关联状态',
      dataIndex: 'status',
      key: 'status',
      render: (_, record, index, action) => {
        return (
          <Tag
            color={
              record.status === 1
                ? 'green'
                : record.status === 2
                ? 'orange'
                : ''
            }
          >
            {record.status === 1
              ? '正常'
              : record.status === 2
              ? '已解绑'
              : '已失效'}
          </Tag>
        );
      },
    },
  ];

  const [userFollowingVisible, setUserFollowingVisible] = useState(false); // 空间关注
  const userFollowingColumns = [
    {
      title: '关注人',
      dataIndex: 'phone',
      key: 'phone',
      render: (_, record, index, action) => {
        return (
          <div>
            <div>{record.followedNickname}</div>
            <div
              style={{
                fontSize: 12,
                color: 'gray',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => {
                const { origin } = window.location;
                const pathname = `/litta-palmer/user/record?id=${record.followedUserId}&phone=${record.followedPhone}`;
                window.open(origin + pathname);
              }}
            >
              {record.followedPhone}
            </div>
          </div>
        );
      },
    },
    {
      title: '关注时间',
      dataIndex: 'ctime',
      key: 'ctime',
    },
    {
      title: ' 关注状态',
      dataIndex: 'optTypeName',
      align: 'center',
      key: 'status',
      render: (_, record, index, action) => {
        return (
          <Tag color={record.optType == 1 ? 'green' : 'orange'}>
            {record.optTypeName}
          </Tag>
        );
      },
    },
  ];

  const [userFollowedVisible, setUserFollowedVisible] = useState(false); // 空间粉丝
  const userFollowedColumns = [
    {
      title: '粉丝',
      dataIndex: 'phone',
      key: 'phone',
      render: (_, record, index, action) => {
        return (
          <div>
            <div>{record.followingNickname}</div>
            <div
              style={{
                fontSize: 12,
                color: 'gray',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => {
                const { origin } = window.location;
                const pathname = `/litta-palmer/user/record?id=${record.followingUserId}&phone=${record.followingPhone}`;
                window.open(origin + pathname);
              }}
            >
              {record.followingPhone}
            </div>
          </div>
        );
      },
    },
    {
      title: '关注时间',
      dataIndex: 'ctime',
      key: 'ctime',
    },
    {
      title: ' 关注状态',
      dataIndex: 'status',
      align: 'center',
      key: 'status',
      render: (_, record, index, action) => {
        return (
          <Tag color={record.optType == 1 ? 'green' : 'orange'}>
            {record.optTypeName}
          </Tag>
        );
      },
    },
  ];
  const [userSpaceVisible, setUserSpaceVisible] = useState(false); // 空间打卡
  const userSpaceColumns = [
    {
      title: '打卡时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: ' 打卡内容',
      dataIndex: 'status',
      key: 'status',
      render: (_, record, index, action) => {
        return (
          <div>
            {record.spaceImgs.length > 0
              ? record.spaceImgs?.map((item) => (
                  <Image
                    style={{ paddingLeft: '10px' }}
                    width={100}
                    height={57}
                    key={item}
                    src={item}
                  />
                ))
              : null}
            <span style={{ marginLeft: '10px' }}>{record.content}</span>
          </div>
        );
      },
    },
    {
      title: '关注状态',
      dataIndex: 'spaceStatus',
      align: 'center',
      key: 'spaceStatus',
      render: (_, record, index, action) => {
        return (
          <Tag color={record.spaceStatus === 1 ? 'green' : ''}>
            {record.spaceStatus === 1 ? '已发布' : '未发布'}
          </Tag>
        );
      },
    },
  ];

  const [userMomentVisible, setUserMomentVisible] = useState(false); // 全身入镜率
  const userMomentColumns = [
    {
      title: '上课时间',
      dataIndex: 'startTime',
      key: 'startTime',
      render: (_, record, index, action) => {
        return (
          <div>
            <div>{record.startTime}</div>
            <div>roomNo: {record.roomNo}</div>
          </div>
        );
      },
    },
    {
      title: '入镜状态',
      dataIndex: 'sceneType',
      key: 'sceneType',
      render: (_, record, index, action) => {
        return <div>{record.sceneType === 1 ? '识别成功' : '识别失败'}</div>;
      },
    },
    {
      title: '入镜截图',
      dataIndex: 'status',
      key: 'status',
      render: (_, record, index, action) => {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <Image.PreviewGroup>
              {record.picUrl2?.map((item) => (
                <Image width={80} key={item} src={item} />
              ))}
            </Image.PreviewGroup>
          </div>
        );
      },
    },
    {
      title: '回放视频',
      dataIndex: 'status',
      key: 'status',
      render: (_, record, index, action) => {
        return record.playBackUrl ? (
          <PlayCircleTwoTone
            onClick={() => playActionUrl(record.playBackUrl)}
          />
        ) : null;
      },
    },
  ];

  const [relatedCoachVisible, setRelatedCoachVisible] = useState(false); // 所属教练
  const relatedCoachColumns = [
    {
      title: '商家',
      dataIndex: 'realName',
      key: 'realName',
      render: (_, record, index, action) => {
        return (
          <div>
            <div>
              {record.coach.nickName}（{record.coach.tenantName}）
            </div>
          </div>
        );
      },
    },
    {
      title: '关联时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '关联方式',
      dataIndex: 'bdTypeDesc',
      key: 'bdTypeDesc',
    },
    {
      title: ' 关联状态',
      dataIndex: 'status',
      align: 'center',
      key: 'status',
      render: (_, record, index, action) => {
        return (
          <Tag color={record.status == 0 ? 'green' : 'orange'}>
            {record.status == 0 ? '启用' : '停用'}
          </Tag>
        );
      },
    },
  ];

  // 获取用户画像数据
  const queryUserPortrait = async () => {
    getUserPortrait({
      requestData: { userId: userId },
    })
      .then(({ code, data, msg }) => {
        if (code === '00000') {
          setUserPortraitData(data);
        } else {
          message.error(msg || '获取用户画像数据失败');
        }
      })
      .catch((error) => {
        console.error('获取用户画像数据出错:', error);
        message.error('获取用户画像数据出错');
      });
  };

  // 钩子函数
  useEffect(() => {
    queryUserOverview();
    sendGetSpaceInfoRequest();
    queryUserPortrait(); // 获取用户画像数据

    getChartIdList({
      requestData: {
        userId: userId,
      },
    }).then((res) => {
      if (res?.code === '00000') {
        if (res?.data != null && res?.data?.length > 0) {
          // 取第一条内容
          setChatId(res?.data[0]?.chatId);
          setChartIdList(res?.data);
          sendAiMessage(res?.data[0]?.chatId);
        }
      }
    });
  }, [step]);

  function sendAiMessage(id) {
    setShowAiLoading(true);
    sendAiAnalyse({
      requestData: {
        chatId: id,
      },
    }).then((res) => {
      if (res?.code === '00000') {
        fetchAiPageList(1, id);
      } else {
        sendAiMessage(chatId);
      }
    });
  }
  function fetchAiPageList(page = 1, id = chatId) {
    pageList({
      requestData: {
        chatId: id,
      },
      page: {
        currentPage: page,
        pageSize: 4,
      },
    }).then(({ code, data, page: p, msg }) => {
      if (code === '00000') {
        const list = Array.isArray(data) ? data : data?.list || [];
        setAiList(list);
        setAiTotal(p?.count ?? data?.count ?? list.length ?? 0);
        setAiCurrentPage(p?.currentPage ?? page);
      } else {
        message.error(msg);
      }
      setShowAiLoading(false);
    });
  }
  const onAiPageChange = (p) => {
    setShowAiLoading(true);
    fetchAiPageList(p);
  };
  function getAiMessageInfo(id) {
    getAiAnalyseInfo({
      requestData: {
        chatId: id,
        // chatId: 'wrZ9i3EAAA6Mor3zywpha9unKFPC3RMw',
      },
    }).then(({ code, data }) => {
      if (code === '00000') {
        setShowAiLoading(false);
        setAiContent(data);
      } else if (code === '110000') {
        getAiMessageInfo(chatId);
      }
    });
  }

  // 获取亲属关系
  const queryUserOverview = async () => {
    userOverview({
      requestData: { userId: userId },
    }).then(({ code, data, msg }) => {
      if (code === '00000') {
        setOverViewData(data);
      } else {
        message.error(msg);
      }
    });
  };

  // 获取用户空间信息
  function sendGetSpaceInfoRequest() {
    getSpaceInfo({
      requestData: { userId: userId },
    }).then(({ code, data, msg }) => {
      if (code === '00000') {
        setGetSpaceInfoData(data);
      } else {
        message.error(msg);
      }
    });
  }

  // 周训练排课
  function checkArrangeDetail() {
    setArrangeModalVisible(true);
  }
  function arrangeDetailView() {
    return (
      <Modal
        title="周训练安排"
        visible={arrangeModalVisible}
        width={800}
        open={arrangeModalVisible}
        onCancel={() => {
          setArrangeModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={arrangeColumns}
          request={async (params) => {
            const { data, page, code } = await weekPlanRecordPage({
              userId,
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 周期约课
  function checkPeriodDetail() {
    setPeriodModalVisible(true);
  }
  function periodDetailView() {
    return (
      <Modal
        title="周期排课"
        visible={periodModalVisible}
        width={800}
        open={periodModalVisible}
        onCancel={() => {
          setPeriodModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={periodColumns}
          request={async (params) => {
            const { data, page, code } = await periodAppointLogPage({
              userId,
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 健康星
  function checkCoinDetail() {
    setCoinModalVisible(true);
  }
  function coinDetailView() {
    return (
      <Modal
        title="健康金领取记录"
        visible={coinModalVisible}
        width={800}
        open={coinModalVisible}
        onCancel={() => {
          setCoinModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={coinColumns}
          request={async (params) => {
            const { data, page, code } = await rewardRecordPage({
              userId,
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 关注公众号
  function checkSubscribeDetail() {
    setSubscribeModalVisible(true);
  }
  function subscribeDetailView() {
    return (
      <Modal
        title="公众号关注记录"
        visible={subscribeModalVisible}
        width={800}
        open={subscribeModalVisible}
        onCancel={() => {
          setSubscribeModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={subscribeColumns}
          request={async (params) => {
            const { data, page, code } = await subrecord({
              requestData: { ...params, userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 家庭账户
  function showUserPoolView() {
    setUserPoolVisible(true);
  }

  function userPoolView() {
    return (
      <Modal
        title="家庭账户"
        open={userPoolVisible}
        width={800}
        onCancel={() => {
          setUserPoolVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={userPoolColumns}
          request={async (params) => {
            const { data, page, code } = await queryUserPool({
              requestData: { userId: userId },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={false}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  function showUserFollowingView() {
    setUserFollowingVisible(true);
  }

  function userFollowingView() {
    return (
      <Modal
        title="空间关注"
        open={userFollowingVisible}
        width={800}
        onCancel={() => {
          setUserFollowingVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={userFollowingColumns}
          request={async (params) => {
            const { data, page, code } = await queryUserFollowing({
              requestData: { userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  function showUserFollowedView() {
    setUserFollowedVisible(true);
  }

  function userFollowedView() {
    return (
      <Modal
        title="空间粉丝"
        open={userFollowedVisible}
        width={800}
        onCancel={() => {
          setUserFollowedVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={userFollowedColumns}
          request={async (params) => {
            const { data, page, code } = await queryUserFollowed({
              requestData: { userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  function showUserSpaceView() {
    setUserSpaceVisible(true);
  }

  function userSpaceView() {
    return (
      <Modal
        title="空间打卡"
        open={userSpaceVisible}
        width={800}
        onCancel={() => {
          setUserSpaceVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={userSpaceColumns}
          request={async (params) => {
            const { data, page, code } = await queryUserSpace({
              requestData: { userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }

            const handleData = data.map((item) => ({
              ...item,
              spaceImgs: item.spaceImg ? JSON.parse(item.spaceImg) : [],
            }));

            return {
              data: handleData,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  function showUserMomentView() {
    setUserMomentVisible(true);
  }

  function userMomentView() {
    return (
      <Modal
        title="全身入镜"
        open={userMomentVisible}
        width={800}
        onCancel={() => {
          setUserMomentVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={userMomentColumns}
          request={async (params) => {
            const { data, page, code } = await queryUserMoment({
              requestData: { userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  function showRelatedCoachView() {
    setRelatedCoachVisible(true);
  }

  function relatedCoachView() {
    return (
      <Modal
        title="所属商家"
        open={relatedCoachVisible}
        width={800}
        onCancel={() => {
          setRelatedCoachVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={relatedCoachColumns}
          request={async (params) => {
            const { data, page, code } = await userOverviewCoach({
              requestData: { userId: userId },
              page: {
                currentPage: params.current,
                pageSize: 100,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 自动续费
  function checkAutoRenewDetail() {
    setAutoRenewModalVisible(true);
  }
  function autoRenewDetailView() {
    return (
      <Modal
        title="自动续费签约记录"
        visible={autoRenewModalVisible}
        width={800}
        open={autoRenewModalVisible}
        onCancel={() => {
          setAutoRenewModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={autoRenewColumns}
          request={async (params) => {
            const { data, page, code } = await renewrecord({
              requestData: { ...params, userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  // 已加企微
  function checkQwDetail() {
    setQwModalVisible(true);
  }
  function qwDetailView() {
    return (
      <Modal
        title="详情"
        visible={qwModalVisible}
        width={800}
        open={qwModalVisible}
        onCancel={() => {
          setQwModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={qwColumns}
          request={async (params) => {
            const { data, page, code } = await alreadyAddWxUser({
              requestData: { ...params, userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey="wxUserId"
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }
  // 已加服务群
  function setExclusiveServiceGroup(record) {
    setServiceGroupExclusive({
      requestData: { userId: userId, chatId: record.chatId },
    }).then(({ code, msg }) => {
      if (code === '00000') {
        alreadyAddWxUserRef?.current?.reload();
        queryUserOverview();
        message.success(msg);
      } else {
        message.error(msg);
      }
    });
  }
  function checkExclusiveServiceGroupDetail() {
    setAlreadyAddWxUserVisible(true);
  }
  function alreadyAddWxUserDetailView() {
    return (
      <Modal
        title="详情"
        visible={alreadyAddWxUserVisible}
        width={800}
        open={alreadyAddWxUserVisible}
        onCancel={() => {
          setAlreadyAddWxUserVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={alreadyAddWxUserColumns}
          actionRef={alreadyAddWxUserRef}
          request={async (params) => {
            const { data, page, code } = await alreadyAddServiceGroup({
              requestData: { ...params, userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey="chatId"
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }
  // 已加打卡
  function checkAlreadyAddDailyGroupDetail() {
    setAlreadyAddDailyGroupQwModalVisible(true);
  }
  function alreadyAddDailyGroupDetailView() {
    return (
      <Modal
        title="详情"
        visible={alreadyAddDailyGroupModalVisible}
        width={800}
        open={alreadyAddDailyGroupModalVisible}
        onCancel={() => {
          setAlreadyAddDailyGroupQwModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={alreadyAddDailyGroupColumns}
          request={async (params) => {
            const { data, page, code } = await alreadyAddDailyGroup({
              requestData: { ...params, userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey="chatId"
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }
  // 地理位置
  function checkLocationDetail() {
    setLocationModalVisible(true);
  }
  function locationDetailView() {
    return (
      <Modal
        title="详情"
        visible={locationModalVisible}
        width={800}
        open={locationModalVisible}
        onCancel={() => {
          setLocationModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={locationColumns}
          request={async (params) => {
            const { data, page, code } = await location({
              requestData: { ...params, userId: userId },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }
  // 动作详情
  function checkActionDetail(actionId, actionName, type) {
    setCurrentActionId(actionId);
    setCurrentActionName(actionName);
    setCurrentMarkType(type);
    setActionModalVisible(true);
    actionRef.current?.reloadAndRest();
  }
  function playActionUrl(url) {
    setPlayerUrl(url);
    setPlayerVisible(true);
  }
  function actionDetailView() {
    return (
      <Modal
        title={currentActionName ?? '动作详情'}
        visible={actionModalVisible}
        width={800}
        open={actionModalVisible}
        onCancel={() => {
          setActionModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={actionColumns}
          actionRef={actionRef}
          request={async (params) => {
            const { data, page, code } = await sportAction({
              requestData: {
                ...params,
                userId: userId,
                actionId: currentActionId,
                markType: currentMarkType,
              },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }

  function getAddedWxUsersString(alreadyAddWxUsers) {
    if (!alreadyAddWxUsers || alreadyAddWxUsers.length === 0) {
      return '-';
    }
    let str = '';
    alreadyAddWxUsers?.forEach((element, index) => {
      if (index > 0) {
        str = str + ',' + element;
      } else {
        str = str + element;
      }
    });
    return str;
  }

  return (
    <div>
      {autoRenewDetailView()}
      {subscribeDetailView()}
      {qwDetailView()}
      {alreadyAddWxUserDetailView()}
      {alreadyAddDailyGroupDetailView()}
      {locationDetailView()}
      {actionDetailView()}
      {userPoolView()}
      {userFollowingView()}
      {userFollowedView()}
      {userSpaceView()}
      {userMomentView()}
      {relatedCoachView()}
      {coinDetailView()}
      {periodDetailView()}
      {arrangeDetailView()}
      {notifyModalView()}
      <ModalVideo
        visible={playerVisible}
        src={playUrl}
        onCancel={() => {
          setPlayerVisible(false);
        }}
        title="视频详情"
      />
      {/*
       * 必须放在 Space 之外：antd Space 是 inline-flex，宽度由「自身内容」决定。
       * 热力图会按容器宽反推格子边长，放进 inline-flex 里就形成测量反馈环
       * （svg 撑开 Space → 量到 svg 宽 → 算回同一个边长），宽度永远锁死在兜底值。
       */}
      <div style={{ marginBottom: 16 }}>
        <CheckInOverview userId={userId} />
      </div>
      <Space direction="vertical">
        <div>
          <Paragraph>
            <blockquote style={{ borderColor: 'skyblue' }}>基础标签</blockquote>
          </Paragraph>
          {overViewData?.baseLabels?.map((e) => {
            return (
              <Tag
                key={e.value}
                color={BASE_LABEL_COLOR[e.type] ?? BASE_LABEL_COLOR_FALLBACK}
              >
                {e.value}
              </Tag>
            );
          })}

          {/* 用户画像表格 */}
          <div style={{ marginTop: '20px' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '20px',
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    用户类型标签
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '38%',
                    }}
                  >
                    {userPortraitData?.basicRequirements?.overview || '-'}
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    用户痛点
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '38%',
                    }}
                  >
                    {userPortraitData?.basicRequirements?.painPoint || '-'}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    目标诉求
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '38%',
                    }}
                  >
                    {userPortraitData?.basicRequirements?.appeal || '-'}
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    购买力
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '38%',
                    }}
                  >
                    {userPortraitData?.purchasingPower ? (
                      <>
                        <div>
                          支付能力:{' '}
                          {userPortraitData.purchasingPower.abilityToPay || '-'}
                        </div>
                        <div>
                          产品使用意愿:{' '}
                          {userPortraitData.purchasingPower
                            .productUseIntention || '-'}
                        </div>
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    训练习惯
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '38%',
                    }}
                  >
                    {userPortraitData?.trainingPreferences?.trainingHabits ||
                      '-'}
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    训练偏好
                  </td>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '38%',
                    }}
                  >
                    {userPortraitData?.trainingPreferences
                      ?.trainingPreferences || '-'}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '12%',
                      backgroundColor: '#fafafa',
                      fontWeight: 'bold',
                    }}
                  >
                    运营策略
                  </td>
                  <td
                    colSpan={3}
                    style={{
                      border: '1px solid #f0f0f0',
                      padding: '12px 16px',
                      width: '88%',
                    }}
                  >
                    {userPortraitData?.operateStrategy ? (
                      <>
                        <div style={{ marginBottom: 5 }}>
                          <div
                            style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          >
                            分析结论
                          </div>
                          <div
                            style={{ whiteSpace: 'pre-wrap', marginLeft: 20 }}
                          >
                            {userPortraitData?.operateStrategy?.conclusion &&
                            userPortraitData.operateStrategy.conclusion.trim()
                              ? userPortraitData.operateStrategy.conclusion
                              : '-'}
                          </div>
                        </div>
                        <div style={{ marginBottom: 5 }}>
                          <div
                            style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          >
                            一句话总结
                          </div>
                          <div
                            style={{ whiteSpace: 'pre-wrap', marginLeft: 20 }}
                          >
                            {userPortraitData?.operateStrategy?.summary &&
                            userPortraitData.operateStrategy.summary.trim()
                              ? userPortraitData.operateStrategy.summary
                              : '-'}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          >
                            详细分析
                          </div>
                          <div
                            style={{ whiteSpace: 'pre-wrap', marginLeft: 20 }}
                          >
                            {userPortraitData?.operateStrategy?.detail &&
                            userPortraitData.operateStrategy.detail.trim()
                              ? userPortraitData.operateStrategy.detail
                              : '-'}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ marginBottom: 5 }}>
                          <div
                            style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          >
                            分析结论
                          </div>
                          <div
                            style={{ whiteSpace: 'pre-wrap', marginLeft: 20 }}
                          >
                            -
                          </div>
                        </div>
                        <div style={{ marginBottom: 5 }}>
                          <div
                            style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          >
                            一句话总结
                          </div>
                          <div
                            style={{ whiteSpace: 'pre-wrap', marginLeft: 20 }}
                          >
                            -
                          </div>
                        </div>
                        <div>
                          <div
                            style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          >
                            详细分析
                          </div>
                          <div
                            style={{ whiteSpace: 'pre-wrap', marginLeft: 20 }}
                          >
                            -
                          </div>
                        </div>
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {chatId && (
          <div>
            <Paragraph>
              <blockquote style={{ borderColor: 'skyblue' }}>
                LITTA POWER
              </blockquote>
              <div>
                <span style={{ fontWeight: 'blod' }}>微信群</span>
                <Select
                  disabled={showAiLoading}
                  placeholder="请选择"
                  value={chatId}
                  onChange={(e) => {
                    setChatId(e);
                    setAiContent(undefined);
                    sendAiMessage(e);
                  }}
                  fieldNames={{
                    label: 'name',
                    value: 'chatId',
                    options: chartIdList,
                  }}
                  options={chartIdList}
                  style={{ width: 300, marginLeft: 15 }}
                >
                  {' '}
                </Select>
              </div>
            </Paragraph>

            <Table
              rowKey={(record, index) => record?.key ?? index}
              columns={aiColumns}
              dataSource={aiList}
              loading={showAiLoading}
              pagination={{
                current: aiCurrentPage,
                total: aiTotal,
                pageSize: 4,
                onChange: onAiPageChange,
                showSizeChanger: false,
              }}
              locale={{ emptyText: '无数据' }}
            />
            <style>
              {`
                .group-modal-dark-header .ant-modal-header {
                  background: #0e2a47;
                }
                .group-modal-dark-header .ant-modal-title {
                  color: #fff;
                }
                .group-modal-dark-header .ant-modal-close {
                  color: #fff;
                }
              `}
            </style>
            <Modal
              title={
                <span
                  style={{
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <LineChartOutlined style={{ marginRight: 8 }} />
                  {aiDetailRecord?.reportTimeRange || '-'} 群互动总结
                </span>
              }
              rootClassName="group-modal-dark-header"
              open={aiDetailVisible}
              onCancel={closeAiDetail}
              footer={[]}
              width={1200}
            >
              {aiDetailRecord && (
                <div>
                  <Typography.Title level={4}>
                    互动概览与关键指标
                  </Typography.Title>
                  <Card style={{ marginTop: 12 }}>
                    <Row gutter={[16, 16]}>
                      <Col span={6}>
                        <div style={{ textAlign: 'center' }}>
                          <UserOutlined
                            style={{ fontSize: 24, color: '#1677ff' }}
                          />
                          <div
                            style={{
                              fontSize: 24,
                              fontWeight: 600,
                              marginTop: 8,
                            }}
                          >
                            {aiDetailRecord?.dataOverview?.keyMetrics
                              ?.memberMessageCount ?? '-'}
                          </div>
                          <div style={{ color: '#888' }}>会员发言条数</div>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div style={{ textAlign: 'center' }}>
                          <MessageOutlined
                            style={{ fontSize: 24, color: '#13c2c2' }}
                          />
                          <div
                            style={{
                              fontSize: 24,
                              fontWeight: 600,
                              marginTop: 8,
                            }}
                          >
                            {aiDetailRecord?.dataOverview?.keyMetrics
                              ?.coachMessageCount ?? '-'}
                          </div>
                          <div style={{ color: '#888' }}>教练发言条数</div>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div style={{ textAlign: 'center' }}>
                          <ClockCircleOutlined
                            style={{ fontSize: 24, color: '#faad14' }}
                          />
                          <div
                            style={{
                              fontSize: 24,
                              fontWeight: 600,
                              marginTop: 8,
                            }}
                          >
                            {(() => {
                              const avg =
                                aiDetailRecord?.dataOverview?.keyMetrics
                                  ?.averageResponseTime;
                              if (!avg) return '-';
                              return `${avg.value}${
                                avg.unit === 'minutes' ? '分钟' : avg.unit || ''
                              }`;
                            })()}
                          </div>
                          <div style={{ color: '#888' }}>平均响应时间</div>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div style={{ textAlign: 'center' }}>
                          <SmileOutlined
                            style={{ fontSize: 24, color: '#52c41a' }}
                          />
                          <div
                            style={{
                              fontSize: 24,
                              fontWeight: 600,
                              marginTop: 8,
                            }}
                          >
                            {aiDetailRecord?.dataOverview?.keyMetrics
                              ?.positiveSentimentRatio || '-'}
                          </div>
                          <div style={{ color: '#888' }}>积极情绪占比</div>
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={[24, 16]} style={{ marginTop: 32 }}>
                      <Col span={12}>
                        <Typography.Title level={5}>
                          活跃时段分布
                        </Typography.Title>
                        {(() => {
                          const dist =
                            aiDetailRecord?.dataOverview
                              ?.activityDistribution || {};
                          const activityData = [
                            {
                              类型: '早晨',
                              数值: toPercentNumber(dist.morning),
                            },
                            { 类型: '中午', 数值: toPercentNumber(dist.noon) },
                            {
                              类型: '晚上',
                              数值: toPercentNumber(dist.evening),
                            },
                            {
                              类型: '深夜',
                              数值: toPercentNumber(dist.lateNight),
                            },
                          ];
                          const config = {
                            data: activityData,
                            xField: '类型',
                            yField: '数值',
                            height: 180,
                            label: {
                              text: '数值',
                              formatter: (datum) => `${datum['数值']}%`,
                            },
                            tooltip: {
                              formatter: (datum) => ({
                                name: datum['类型'],
                                value: `${datum['数值']}%`,
                              }),
                            },
                            yAxis: { labelFormatter: (v) => `${Number(v)}%` },
                          };
                          return <Column {...config} />;
                        })()}
                      </Col>
                      <Col span={12}>
                        <Typography.Title level={5}>情绪分析</Typography.Title>
                        {(() => {
                          const senti =
                            aiDetailRecord?.dataOverview?.sentimentAnalysis ||
                            {};
                          return (
                            <div>
                              <Progress
                                percent={toPercentNumber(senti.positive)}
                                strokeColor="#52c41a"
                                showInfo
                                format={(p) => `${p}% 积极`}
                                style={{ width: '85%' }}
                              />
                              <Progress
                                percent={toPercentNumber(senti.neutral)}
                                strokeColor="#faad14"
                                showInfo
                                format={(p) => `${p}% 中性`}
                                style={{ width: '85%', marginTop: 32 }}
                              />
                              <Progress
                                percent={toPercentNumber(senti.negative)}
                                strokeColor="#f5222d"
                                showInfo
                                format={(p) => `${p}% 消极`}
                                style={{ width: '85%', marginTop: 32 }}
                              />
                            </div>
                          );
                        })()}
                      </Col>
                    </Row>
                  </Card>
                  <Typography.Title level={4} style={{ marginTop: 24 }}>
                    小助手与会员打卡数据
                  </Typography.Title>
                  <Card style={{ marginTop: 12 }}>
                    {(() => {
                      const tool =
                        aiDetailRecord?.dataOverview?.toolInteraction || {};
                      return (
                        <Row gutter={0}>
                          <Col
                            flex="20%"
                            style={{ borderRight: '1px solid #f0f0f0' }}
                          >
                            <div
                              style={{ textAlign: 'center', padding: '8px 0' }}
                            >
                              <PictureOutlined
                                style={{ fontSize: 24, color: '#1677ff' }}
                              />
                              <div
                                style={{
                                  fontSize: 24,
                                  fontWeight: 600,
                                  marginTop: 8,
                                }}
                              >
                                {tool.imageUploadCount ?? '-'}
                              </div>
                              <div style={{ color: '#888' }}>
                                用户在群内发图数量
                              </div>
                            </div>
                          </Col>
                          <Col
                            flex="20%"
                            style={{ borderRight: '1px solid #f0f0f0' }}
                          >
                            <div
                              style={{ textAlign: 'center', padding: '8px 0' }}
                            >
                              <CalendarOutlined
                                style={{ fontSize: 24, color: '#1677ff' }}
                              />
                              <div
                                style={{
                                  fontSize: 24,
                                  fontWeight: 600,
                                  marginTop: 8,
                                }}
                              >
                                {tool.checkInCount ?? '-'}
                              </div>
                              <div style={{ color: '#888' }}>群内打卡数量</div>
                            </div>
                          </Col>
                          <Col
                            flex="20%"
                            style={{ borderRight: '1px solid #f0f0f0' }}
                          >
                            <div
                              style={{ textAlign: 'center', padding: '8px 0' }}
                            >
                              <RobotOutlined
                                style={{ fontSize: 24, color: '#1677ff' }}
                              />
                              <div
                                style={{
                                  fontSize: 24,
                                  fontWeight: 600,
                                  marginTop: 8,
                                }}
                              >
                                {tool.assistantReplyCount ?? '-'}
                              </div>
                              <div style={{ color: '#888' }}>
                                小助手回复数量
                              </div>
                            </div>
                          </Col>
                          <Col
                            flex="20%"
                            style={{ borderRight: '1px solid #f0f0f0' }}
                          >
                            <div
                              style={{ textAlign: 'center', padding: '8px 0' }}
                            >
                              <MessageOutlined
                                style={{ fontSize: 24, color: '#1677ff' }}
                              />
                              <div
                                style={{
                                  fontSize: 24,
                                  fontWeight: 600,
                                  marginTop: 8,
                                }}
                              >
                                {tool.userAssistantInteractionRounds ?? '-'}
                              </div>
                              <div style={{ color: '#888' }}>
                                用户与小助手互动轮数
                              </div>
                            </div>
                          </Col>
                          <Col flex="20%">
                            <div
                              style={{ textAlign: 'center', padding: '8px 0' }}
                            >
                              <PieChartOutlined
                                style={{ fontSize: 24, color: '#1677ff' }}
                              />
                              <div
                                style={{
                                  fontSize: 24,
                                  fontWeight: 600,
                                  marginTop: 8,
                                }}
                              >
                                {tool.assistantCoverageRatio ?? '-'}
                              </div>
                              <div style={{ color: '#888' }}>
                                小助手回复覆盖率
                              </div>
                            </div>
                          </Col>
                        </Row>
                      );
                    })()}
                  </Card>
                  <Typography.Title level={4} style={{ marginTop: 24 }}>
                    关键洞察
                  </Typography.Title>
                  <Card style={{ marginTop: 12 }}>
                    <Table
                      columns={insightColumns}
                      dataSource={(
                        aiDetailRecord?.keyBusinessInsights?.insights || []
                      ).map((it, i) => ({
                        ...it,
                        key: i,
                      }))}
                      pagination={false}
                    />
                  </Card>
                </div>
              )}
            </Modal>
          </div>
        )}
        <div>
          <Paragraph>
            <blockquote style={{ borderColor: 'skyblue' }}>互动数据</blockquote>
          </Paragraph>
          <Descriptions
            labelStyle={{ width: '120px' }}
            contentStyle={{ width: '280px' }}
            column={4}
            size="small"
            bordered
          >
            <Descriptions.Item label="已加企微：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {getAddedWxUsersString(overViewData?.alreadyAddWxUsers)}
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkQwDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="已加群：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {overViewData?.alreadyAddServiceGroup
                    ? overViewData?.alreadyAddServiceGroup
                    : '-'}
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkExclusiveServiceGroupDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="已加打卡群：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {overViewData?.alreadyAddDailyGroup
                    ? overViewData?.alreadyAddDailyGroup
                    : '-'}
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkAlreadyAddDailyGroupDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="运动目标：">
              {overViewData?.sportTarget ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="提醒时间：">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <span>{overViewData?.notifyTime ?? '-'}</span>
                <a
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    flexShrink: 0,
                    marginLeft: 8,
                  }}
                  onClick={openNotifyModal}
                >
                  <span>启用</span>
                  <span>状态</span>
                </a>
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="运动计划周期：">
              {overViewData?.healthPlanPeriod ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="关注公众号：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>{overViewData?.subTime ?? '-'}</span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkSubscribeDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="填写问卷：">
              {overViewData?.questionnaireTime ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="家庭账户：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {getSpaceInfoData?.familyNum
                    ? getSpaceInfoData?.familyNum
                    : '-'}
                  人
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={showUserPoolView}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="空间关注：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {getSpaceInfoData?.followingNum
                    ? getSpaceInfoData?.followingNum
                    : '-'}
                  人
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={showUserFollowingView}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="空间粉丝：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {getSpaceInfoData?.followedNum
                    ? getSpaceInfoData?.followedNum
                    : '-'}
                  人
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={showUserFollowedView}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="空间打卡：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {getSpaceInfoData?.spaceNum
                    ? getSpaceInfoData?.spaceNum
                    : '-'}
                  次
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={showUserSpaceView}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="空间获赞：">
              <span>
                {getSpaceInfoData?.newsLikeTotal
                  ? getSpaceInfoData?.newsLikeTotal
                  : '-'}
                次
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="全身入镜率：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {getSpaceInfoData?.rate ? getSpaceInfoData?.rate : '-'}%
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={showUserMomentView}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="所属商家：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                {/* <a
                  href={`/athena/merchantProfile/detail?tenantId=${overViewData?.coach?.tenantId}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>{overViewData?.coach?.nickName || '-'}</span>
                  <span>（{overViewData?.coach?.tenantName || '-'}）</span>
                </a> */}
                <div
                  style={{ color: '#1890ff', cursor: 'pointer' }}
                  onClick={() => {
                    if (!overViewData?.coach?.tenantId) {
                      message.warn('暂未找到绑定的商家');
                      return;
                    }
                    window.open(
                      `/athena/merchantProfile/detail?tenantId=${overViewData?.coach?.tenantId}`,
                      '_blank',
                    );
                  }}
                >
                  <span>{overViewData?.coach?.nickName || '-'}</span>
                  <span>（{overViewData?.coach?.tenantName || '-'}）</span>
                </div>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={showRelatedCoachView}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="周训练安排：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {overViewData?.weekPlanRecord
                    ? overViewData?.weekPlanRecord?.operationTime +
                      ' ' +
                      sourceEnum?.[overViewData?.weekPlanRecord?.source]?.text
                    : '-'}
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkArrangeDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="周期排课：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>
                  {overViewData?.appointClassRecord?.length > 0
                    ? overViewData?.appointClassRecord.map((e, index) => (
                        <Tag color="success" key={index}>{`${
                          FrequencyDays[e.daySeq]
                        } ${e.appointTime}`}</Tag>
                      ))
                    : '-'}
                </span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkPeriodDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="天天私教：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>{overViewData?.littaPtLastLoginTime}</span>
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="LITTA健康：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>{overViewData?.littaLiveLastLoginTime}</span>
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="健身大人物：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>{overViewData?.bigBangLastLoginTime}</span>
              </div>
            </Descriptions.Item>
          </Descriptions>
        </div>
        <div>
          <Paragraph>
            <blockquote style={{ borderColor: 'skyblue' }}>订单行为</blockquote>
          </Paragraph>
          <Descriptions
            labelStyle={{ width: '180px' }}
            contentStyle={{ width: '200px' }}
            column={4}
            size="small"
            bordered
          >
            <Descriptions.Item label="指导课剩余：">
              <span>
                {overViewData?.guideNum ? overViewData?.guideNum : '-'}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="AI课权益到期：">
              {overViewData?.aiRightExpireDate ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="私教剩余：">
              {overViewData?.ptNum ?? '-'}
            </Descriptions.Item>

            <Descriptions.Item label="付费订单次数">
              {overViewData?.payOrderNum ?? '-'}次
            </Descriptions.Item>
            <Descriptions.Item label="消费总金额">
              {overViewData?.payAmount >= 0
                ? overViewData?.payAmount / 100.0
                : '-'}
              元
            </Descriptions.Item>
            <Descriptions.Item label="SP课订单">
              {overViewData?.paySpOrderNum ?? '-'}笔
            </Descriptions.Item>
            <Descriptions.Item label="转介绍订单">
              {overViewData?.inviteOrderNum ?? '-'}笔
            </Descriptions.Item>

            <Descriptions.Item label="自动续费：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span>{overViewData?.autoRenew ?? '-'}</span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkAutoRenewDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="有续费行为：">
              {overViewData?.renewalBehavior ? '是' : '否'}
            </Descriptions.Item>
            <Descriptions.Item label="用户价值：">
              {overViewData?.highValueUser ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="续费可行性：">
              {overViewData?.renewalFeasibility ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="健康金：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                {overViewData?.rewardStatistics ? (
                  <div>
                    <div>{`待领取：${overViewData?.rewardStatistics?.notClaimedAmount}`}</div>
                    <div>{`已领取：${overViewData?.rewardStatistics?.claimedAmount}`}</div>
                  </div>
                ) : (
                  '-'
                )}

                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkCoinDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div>
          <Paragraph>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <blockquote style={{ borderColor: 'skyblue', marginBottom: 0 }}>
                运动数据
              </blockquote>
              <Button
                type="link"
                onClick={() => history.push(`/thirdparty?userId=${userId}`)}
              >
                查看三方授权
              </Button>
            </div>
          </Paragraph>
          <Descriptions
            labelStyle={{ width: '180px' }}
            contentStyle={{ width: '200px' }}
            column={4}
            size="small"
            bordered
          >
            <Descriptions.Item label="AI累计完课：">
              {overViewData?.aiSportData.completeClass ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="累计运动：">
              {overViewData?.aiSportData.totalSport ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="运动频率">
              {overViewData?.aiSportData.sportFrequency ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="最近完课：">
              {overViewData?.aiSportData.lastCompleteClassTime ?? '-'}
            </Descriptions.Item>

            <Descriptions.Item label="私教累计完课：">
              {overViewData?.ptSportData.completeClass ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="累计运动：">
              {overViewData?.ptSportData.totalSport ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="运动频率：">
              {overViewData?.ptSportData.sportFrequency ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="最近完课：">
              {overViewData?.ptSportData.lastCompleteClassTime ?? '-'}
            </Descriptions.Item>
            <Divider />
            <Divider />
            <Divider />
            <Divider />
            <Descriptions.Item label="最近设备：">
              {overViewData?.recentDevice ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="系统版本：">
              {overViewData?.sysVersion ?? '-'}
            </Descriptions.Item>

            <Descriptions.Item label="微信版本：">
              {overViewData?.wxVersion ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="地理位置：">
              <div
                style={{
                  display: 'flex',
                }}
              >
                <span> {overViewData?.location ?? '-'}</span>
                <Button
                  type="link"
                  icon={<FileSearchOutlined />}
                  onClick={checkLocationDetail}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </div>
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div>
          <Paragraph>
            <blockquote style={{ borderColor: 'skyblue' }}>动作数据</blockquote>
          </Paragraph>
          <Row>
            <Col span={12}>
              <Space direction="vertical" style={{ width: '95%' }}>
                <label>问题动作TOP20</label>
                <Descriptions
                  labelStyle={{ width: '180px' }}
                  contentStyle={{ width: '200px' }}
                  column={1}
                  size="small"
                  bordered
                >
                  {[
                    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                    17, 18, 19,
                  ].map((index) => {
                    const model =
                      index < overViewData?.problemActions.length
                        ? overViewData?.problemActions[index]
                        : undefined;
                    return index < overViewData?.problemActions.length ? (
                      <Descriptions.Item key={index} label={model.actionName}>
                        <div
                          style={{
                            display: 'flex',
                          }}
                        >
                          <span>{model.num}</span>
                          <Button
                            type="link"
                            icon={<FileSearchOutlined />}
                            onClick={() =>
                              checkActionDetail(
                                model.actionId,
                                model.actionName,
                                2,
                              )
                            }
                            style={{
                              marginLeft: 'auto',
                            }}
                          />
                        </div>
                      </Descriptions.Item>
                    ) : (
                      <Descriptions.Item
                        key={index}
                        style={{ height: '48.5px' }}
                        label="-"
                      >
                        -
                      </Descriptions.Item>
                    );
                  })}
                </Descriptions>
              </Space>
            </Col>
            <Col span={12}>
              <Space direction="vertical" style={{ width: '95%' }}>
                <label>完美动作TOP20</label>
                <Descriptions
                  labelStyle={{ width: '180px' }}
                  contentStyle={{ width: '200px' }}
                  column={1}
                  size="small"
                  bordered
                >
                  {[
                    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                    17, 18, 19,
                  ].map((index) => {
                    const model =
                      index < overViewData?.perfectActions.length
                        ? overViewData?.perfectActions[index]
                        : undefined;
                    return index < overViewData?.perfectActions.length ? (
                      <Descriptions.Item key={index} label={model.actionName}>
                        <div
                          style={{
                            display: 'flex',
                          }}
                        >
                          <span>{model.num}</span>
                          <Button
                            type="link"
                            icon={<FileSearchOutlined />}
                            onClick={() =>
                              checkActionDetail(
                                model.actionId,
                                model.actionName,
                                3,
                              )
                            }
                            style={{
                              marginLeft: 'auto',
                            }}
                          />
                        </div>
                      </Descriptions.Item>
                    ) : (
                      <Descriptions.Item
                        key={index}
                        label="-"
                        style={{ height: '48.5px' }}
                      >
                        -
                      </Descriptions.Item>
                    );
                  })}
                </Descriptions>
              </Space>
            </Col>
          </Row>
        </div>
      </Space>
    </div>
  );
};

export default OverView;
